import React, { ReactNode } from 'react'
import { Box, DisplayPosition } from '@gousto-internal/citrus-react'
import { HeroSlide } from './components/HeroSlide/HeroSlide'
import { HeroSlidesConfig } from '../../config'

type CarouselProps = {
  heroSlides?: HeroSlidesConfig
  heroTitleBox?: ReactNode
}

export const Carousel = ({ heroSlides, heroTitleBox }: CarouselProps) => {
  return (
    <Box width="100%" data-testid="carousel">
      <Box position={DisplayPosition.Absolute} width={'100%'}>
        <HeroSlide slides={heroSlides} heroTitleBox={heroTitleBox} />
      </Box>
    </Box>
  )
}
